import { Separator } from "@/components/ui/separator";
import { Dot, EllipsisVertical, User, X } from "lucide-react";
import React, { useEffect, useState } from "react";
import FormInputField from "@/components/lib/from-input-field";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { useForm } from "react-hook-form";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Form } from "@/components/ui/form";
import { Button } from "@/components/ui/button";
import { toast } from "react-hot-toast";
import useAuth from "@/hooks/useAuth";
import { createBookingTable, createRoom, createTable, getAllRooms, getAllRoomsWithoutPagination, getAllTablesWithRoom, quickBookingTable, updateRoom, updateTable } from "@/api/table-floor/tableFloor";
import { useSelector, useDispatch } from "react-redux";
import { fetchAllTables } from "@/redux/slice/table-slice/table-slice";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { getAllStaff } from "@/api/staff";
import { restaurant_id } from "@/api/lib/url";
import { fetchAllStaff } from "@/redux/slice/staff-management/staff-attendance";
import { format } from "date-fns";

const addNewFloorCardSchema = z.object({
  floor_id: z.number().min(1, "Floor is required"),
  room_id: z.number().min(1, "Room is required"),
  table_id: z.number().min(1, "Table is required"),
  guest: z.coerce.number().min(1, "Guest is required"),
  reservation_type: z.string().min(1, "Reservation type is required"),
  staff_id: z.coerce.number().optional(),
  reservation_date: z.preprocess((val) => {
    if (!val) return undefined;
    if (typeof val === "string") return val.split("T")[0];
    if (val instanceof Date) return format(val, "yyyy-MM-dd");
    return String(val);
  }, z.string({ required_error: "End date is required" })),
  start_time: z.string().min(1, "Start time is required"),
  end_time: z.string().min(1, "End time is required"),
});

const QuickTableModal = ({ isOpen, onClose }) => {
  
  const { tables, floors, selectedFloor, selectedRoom } = useSelector(
    (state) => state.table.table
  );
  const { staffList } = useSelector(
      (state) => state.staffManage.attendance
    );
  const [loading, setLoading] = useState(false);
  const [showIsChild, setShowIsChild] = useState(false);
  const { user } = useAuth();
  const [customer, setCustomer] = useState([])
  const [rooms, setRooms] = useState([])
  // const [tables, setTables] = useState([])
  // console.log(customer);
  // console.log(rooms);
  
  
  const [selectedPayerUser, setSelectedPayerUser] = useState([]);
  const dispatch = useDispatch();  

  const form = useForm({
    resolver: zodResolver(addNewFloorCardSchema),
    mode: "onChange",
    defaultValues: {
      floor_id: "",
      room_id: "",
      table_id: "",
      guest: "",
      reservation_type: "",
      staff_id: "",
      reservation_date: format(new Date(), "yyyy-MM-dd"),
      start_time: "",
      end_time: "",
    },
  });

  useEffect(() => {
    if (showIsChild && staffList.length === 0) {
      dispatch(fetchAllStaff());
    }
  }, [showIsChild])


  const floorId = form.watch("floor_id");
  useEffect(() => {
    if(floorId){
      form.setValue("room_id", "");
      setRooms([]);
      
      getAllRoomsWithoutPagination(user?.restaurant_id, floorId)
        .then((res) => {
          if (res.status === "success") {
            setRooms(res.data.rooms);
          }
        })
        .catch((err) => console.log(err));
    }
  }, [floorId]);

  const roomId = form.watch("room_id");
  useEffect(() => {
    if(roomId){
      // getAllTablesWithRoom(roomId)
      //   .then((res) => {
      //     if (res.status === "success") {
      //       setTables(res.data.tables);
      //     }
      //   })
      //   .catch((err) => console.log(err));
      dispatch(fetchAllTables(Number(roomId)));
    }
  }, [roomId]);

  const { reset } = form;
  const addFloorCardData = async (data) => {
    // console.log(form.error())
    // console.log(data);
    // return;
    // console.log(data);
    
    setLoading(true);

    const payload =
      {
        ...data,
        staff_id: showIsChild ? data.staff_id : null,
        restaurant_id: user.restaurant_id,
      };

    try {
      let res;
      res = await quickBookingTable(payload);
      if (res.status === "success") {
        toast.success("Booked Table successfully!");
        
        onClose();
        reset();
        // IMPORTANT: refresh tables for selected room to reflect changes immediately
        if (data.room_id || selectedRoom?.id) {
          const roomId = data.room_id || selectedRoom?.id;
          dispatch(fetchAllTables(Number(roomId)));
        }
      } else {
        toast.error(res.message || "Something went wrong!");
      }
    } catch (err) {
      toast.error(err?.message || "Failed to process Floor Card");
    } finally {
      setLoading(false);
    }
  };

  // console.log(form.formState.errors);

  if (!isOpen) return null;

  return (
    <>
      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50">
        <Card className="bg-cblack4 text-cwhite w-[600px] h-[90vh] overflow-scroll">
          <CardHeader className="flex flex-row justify-between items-center">
            <CardTitle className="text-cwhite text-xl font-medium">Quick Booking</CardTitle>
            <X onClick={onClose} className="cursor-pointer" size={16} />
          </CardHeader>
          <Separator />
          <CardContent>
            <div className="mt-8">
              <Form {...form}>
                <form onSubmit={form.handleSubmit(addFloorCardData)} className="flex flex-col gap-5">
                  <FormInputField
                    name="floor_id"
                    style="bg-cblack3"
                    placeholder={"Select Floor"}
                    form={form}
                    type="select"
                    parseAs="string"
                    // selectOption={[
                    //   { label: "In Person", value: "in_person" },
                    //   { label: "Phone Call", value: "phone_call" },
                    //   { label: "Online", value: "online" },
                    // ]}
                    selectOption={floors?.filter(item => item.status !== "inactive")?.map(item => ({
                      label: item.name,
                      value: item.id,
                    }))}
                    label={"Floor"}
                    required={true}
                  />
                  <FormInputField
                    name="room_id"
                    style="bg-cblack3"
                    placeholder={"Select Room"}
                    form={form}
                    type="select"
                    parseAs="string"
                    selectOption={rooms?.filter(item => item.status !== "inactive")?.map(item => ({
                      label: item.name,
                      value: item.id,
                    }))}
                    label={"Room"}
                    required={true}
                  />
                  <FormInputField
                    name="table_id"
                    style="bg-cblack3"
                    placeholder={"Select Table"}
                    form={form}
                    type="select"
                    parseAs="string"
                    selectOption={tables?.map(item => ({
                      label: item.name,
                      value: item.id,
                    }))}
                    label={"Table"}
                    required={true}
                  />
                  <FormInputField name="guest" style="bg-cblack3" placeholder={"Enter Number of Guest"} form={form} type="number" label={"Number Of Guest"} required={true} />
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <FormInputField
                        name="reservation_type"
                        style="bg-cblack3"
                        placeholder={"Reservation Type*"}
                        form={form}
                        type="select"
                        parseAs="string"
                        selectOption={[
                          { label: "In Person", value: "in_person" },
                          { label: "Phone Call", value: "phone" },
                          { label: "Online", value: "online" },
                          { label: "Other", value: "other" },
                        ]}
                        label={"Reservation Type"}
                        required={true}
                      />
                    </div>
                    <div className="space-y-2">
                      <div className="flex gap-2 items-center">
                        <Switch
                          className="data-[state=unchecked]:bg-neutral-500"
                          checked={showIsChild}
                          onCheckedChange={(val) => setShowIsChild(val)}
                        />
                        <Label>Assign Staff</Label>
                      </div>
      
                      {showIsChild && (
                        <FormInputField
                          name="staff_id"
                          style="bg-cblack3"
                          placeholder={"Select staff"}
                          form={form}
                          type="select"
                          parseAs="string"
                          selectOption={staffList?.map(item => ({
                            label: item?.user?.first_name + " " + item?.user?.last_name,
                            value: item?.user?.id,
                          }))}
                        />
                      )}
                    </div>
                  </div>
                  <div className="grid grid-cols-4 gap-2">
                    <div className="col-span-2">
                      <FormInputField name="reservation_date" style="bg-cblack3" placeholder={"Select Date"} form={form} type="date" dateFormat="yyyy-MM-dd" label={"Date"} required={true} />
                    </div>
                    <div className="col-span-1">
                      <FormInputField name="start_time" style="bg-cblack3" placeholder={"Select Start Time"} form={form} type="time" label={"Start Time"} required={true} />
                    </div>
                    <div className="col-span-1">
                      <FormInputField name="end_time" style="bg-cblack3" placeholder={"Select End Time"} form={form} type="time" label={"End Time"} />
                    </div>
                  </div>
                  <div className="mt-4 flex gap-5 w-full">
                    <Button className="w-full bg-cred text-white" onClick={onClose}>
                        Cancel
                    </Button>

                    <Button isLoading={loading} className="w-full bg-cyellow">
                        Confirm
                    </Button>
                  </div>
                </form>
              </Form>
            </div>
          </CardContent>
        </Card>
      </div>
    </>
  );
};

export default QuickTableModal;
